import { call, put, takeEvery } from 'redux-saga/effects';
import { inventoryActionCreators } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { fetchInventory } from '../inventoryApi';
import { IInventoryItem } from '../inventoryInterfaces';

function* fetchInventorySaga(action: ReturnType<typeof inventoryActionCreators.fetch>) {
  const response: IApiExecuteRespone<Record<string, IInventoryItem>> = yield call(fetchInventory, action.payload);

  if (!response.requestFailed && response.value) {
    yield put(inventoryActionCreators.set(response.value));
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(inventoryActionCreators.disableLoading(action.payload));
}

export function* watchFetchInventory() {
  yield takeEvery(inventoryActionCreators.fetch.match, fetchInventorySaga);
}
